module.exports = __webpack_public_path__ + "static/media/mastercard.88f65316.svg";